<template>
    <div v-if="hasSecurities">
        <x-select
            v-model="selectedSecurities"
            :items="securityTypes"
            label="Securities?"
            :placeholder="!hasSecurities ? 'No securities available': ' '"
            item-value="id"
            item-text="name"
            append-icon="keyboard_arrow_down"
            multiple
            outline
            :menu-props="{
                offsetY: true,
                value: menuOpen,
                openOnClick: true,
                closeOnClick: true,
                contentClass: 'input-fixed-width-menu'
            }"
            :disabled="!hasSecurities || oneSecurityAvailable"
            attach
        >
            <template slot="selection" slot-scope="{item, index}">
                <template v-if="index === 0">
                    <span v-if="selectedSecurities.length === 1">
                        {{ item.name }}
                    </span>
                    <span v-else-if="selectedSecurities.length > 1">
                        {{ selectedSecurities.length }} selected
                    </span>
                </template>
            </template>
        </x-select>
    </div>
</template>
<script>
    import CheckIcon from '~/components/Shared/UIComponents/CheckIcon';

    export default {
        name: "AddEditSecurities",
        components: {
            CheckIcon
        },
        props: ['value', 'offer', 'facilityId'],
        created: function () {
            this.fetchData();
        },
        data: function () {
            return {
                hasSecurities: false,
                securityTypes: [],
                selectedSecurities: [],
                oneSecurityAvailable: false,
                menuOpen: false
            }
        },
        methods: {
            fetchData: async function () {
                const securityUrl = this.facilityId ? `insurer/security/list/${this.facilityId}` : `insurer/security/list`;

                this.securityTypes = (await axios.get(this.$root.api(securityUrl))).data.data;

                this.oneSecurityAvailable = this.securityTypes.length === 1;

                if (this.securityTypes.length > 0) {
                    this.selectedSecurities = this.getSecurityTypeIds();
                    this.hasSecurities = true
                }

                this.$emit('hasSecurities', this.hasSecurities);
            },
            getSecurityTypeIds: function () {
                return this.securityTypes.map(function (security) {
                    return security.id;
                });
            },
        },
        watch: {
            selectedSecurities: {
                handler: async function (securityIds) {
                    (await axios.put(this.$root.api(`insurer/security/sync-with-offer`),
                        {
                            securities: securityIds,
                            offer: this.offer.id
                        }
                    )).data.data;
                },
                deep: true,
                immediate: true,
            },
            securityTypes: {
                handler: function (newVal) {
                    this.subjectivities = newVal.filter(s => s.selected === true).map(s => s.name);
                },
                deep: true,
            },
        }
    }
</script>
